import * as _ from 'lodash';
import DatePicker from '@mui/lab/MobileDatePicker';
import TextField from '@mui/material/TextField';
import { withFormsy } from 'formsy-react';
import { str2date, date2str } from 'utils/date';
import CurrentUser from 'auth/currentUser';
import React from 'react';

function DatePickerFormsy(props) {
  const importedProps = _.pick(props, [
    'autoComplete',
    'autoFocus',
    'children',
    'className',
    'defaultValue',
    'disabled',
    'FormHelperTextProps',
    'fullWidth',
    'id',
    'InputLabelProps',
    'inputProps',
    'InputProps',
    'inputRef',
    'label',
    'multiline',
    'name',
    'onBlur',
    'onChange',
    'onFocus',
    'placeholder',
    'required',
    'rows',
    'rowsMax',
    'select',
    'SelectProps',
    'type',
    'variant',
    'color',
  ]);

  const { errorMessage, dateMin, dateMax, description } = props;
  const currentLocale = CurrentUser.getInstance().getLocale();
  const value = props.value || '';

  if (dateMax) {
    importedProps['maxDate'] = str2date(dateMax);
  }
  if (dateMin) {
    importedProps['minDate'] = str2date(dateMin);
  }

  function changeValue(date) {
    const str = date2str(date);
    props.setValue(str);
    if (props.onChange) {
      props.onChange(str);
    }
  }

  return (
    <DatePicker
      {...importedProps}
      inputVariant="outlined"
      inputFormat="yyyy-MM-dd"
      value={value || null}
      onChange={changeValue}
      error={Boolean((!props.isPristine && props.showRequired) || errorMessage)}
      renderInput={(props) => {
        const { inputProps } = props;
        const { value } = inputProps;
        if (value) {
          const options = { year: 'numeric', month: 'short', day: 'numeric' };
          const date = new Date(value);
          const localString = date.toLocaleDateString(currentLocale, options);
          const formattedProps = {
            ...props,
            inputProps: {
              ...inputProps,
              value: localString,
            },
          };
          return <TextField {...formattedProps} helperText={errorMessage ?? description} />;
        }
        return <TextField {...props} helperText={errorMessage ?? description} />;
      }}
    />
  );
}

export default React.memo(withFormsy(DatePickerFormsy));
